export default __webpack_public_path__ + "static/media/icon-vps-round.0af67368.svg";